var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_335_2347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 8.66666H8.66662V12C8.66662 12.3667 8.36662 12.6667 7.99995 12.6667C7.63328 12.6667 7.33328 12.3667 7.33328 12V8.66666H3.99995C3.63328 8.66666 3.33328 8.36666 3.33328 7.99999C3.33328 7.63333 3.63328 7.33333 3.99995 7.33333H7.33328V3.99999C7.33328 3.63333 7.63328 3.33333 7.99995 3.33333C8.36662 3.33333 8.66662 3.63333 8.66662 3.99999V7.33333H11.9999C12.3666 7.33333 12.6666 7.63333 12.6666 7.99999C12.6666 8.36666 12.3666 8.66666 11.9999 8.66666Z",
    fill: "#21005D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_335_2347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.5757fbe0362c8ac4ff73fad8d75b1d56.svg";
export { ForwardRef as ReactComponent };